import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-sparkline',
	templateUrl:'./WaSparklineProPage.html',
	styles: [],
	styleUrls:['./WaSparklineProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaSparklineProPage
{
	mdContent_449 = `\`\`\`java
import com.jwebmp.webawesomepro.components.chart.WaSparkline;
\`\`\``;
	mdContent_450 = `\`\`\`java
new WaSparkline<>()
\`\`\``;
	mdContent_451 = `\`\`\`java
var spark = new WaSparkline<>();
// Data is bound via Angular template or slot content
\`\`\``;
}
